<template>
  <div class="home">
    <main class="main" data-v-109a143a="">
      <div data-v-1f4d0977="" class="privacy-view">
        <header data-v-1f4d0977="">
          <div  class="container">
            <h1 data-v-1f4d0977="">隐私政策</h1>
          </div>
        </header>
        <main data-v-1f4d0977="">
          <div data-v-1f4d0977="" class="container">
            <section data-v-1f4d0977="" class="intro">
              <h2 data-v-1f4d0977="" style="text-align: left;">欢迎访问我们的隐私政策</h2>
              <p data-v-1f4d0977="" style="text-align: left;">香港乾元有限公司ERP高度重视用户隐私。本隐私政策涵盖了我们如何收集、使用、共享和保护您的个人信息，特别是针对沃尔玛 Marketplace 卖家及其客户的个人身份信息（PII）。我们承诺符合全球隐私法规，包括中华人民共和国法律、欧洲《通用数据保护条例》（GDPR）、《加州消费者隐私法》（CCPA）等，并遵循 Walmart Marketplace API 及 OAuth 2.0 授权相关的隐私和安全合规要求。
                本网站(包含https://www.开发者官网.com及下级各子域名)尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务（包含且并不局限于网络下单服务、订单履约运输服务、网上订单处理服务），本网站会按照本隐私权政策的规定搜集、使用和披露您的个人信息。但本网站将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本网站不会将这些信息对外披露或向第三方提供。本网站会不时更新本隐私权政策。 本网站由深圳市香港乾元有限公司ERP有限公司开发维护，有任何疑问可联系我们的客服（邮箱：zoujianzhou@qianyuanhk.com）。</p>
              <p data-v-1f4d0977="" style="text-align: left;">本隐私政策详细说明了我们如何收集、使用、保护和分享您的个人信息，请您仔细阅读。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">一、 我们收集的信息</h2>
              <p data-v-1f4d0977="" style="text-align: left;">为了提供更好的服务，我们可能会收集和使用以下类型的信息：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(a).</strong>在您注册本网站帐号时，您根据本网站要求提供的个人注册信息；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(b).</strong>在您使用本网站网络服务，或访问本网站平台网页时，本网站自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(c).</strong> 您在商城注册时提供给商城运营企业的客户信息及您在商城维护的收货人信息、订单的收货人信息等；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(d).</strong>您的企业在使用本网站过程中注册内部用户账号所填写的个人信息；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(e).</strong>本网站通过合法途径从商业伙伴处取得的用户个人数据。
在通过 Walmart Marketplace API 与沃尔玛卖家合作时，我们可能会收集并处理以下类型的个人身份信息（PII）：卖家账户信息、订单信息、买家联系信息（如买家的姓名、收货地址、电话号码等）。我们将严格遵守 Walmart 关于 API 数据访问及 OAuth 2.0 授权的规定，不会收集、存储、或处理与服务无关的个人身份信息。
                </li>
              </ul>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">1. 共享</h2>
              <p data-v-1f4d0977="" style="text-align: left;">我们不会与其他组织和个人共享您的用户信息，但以下情况除外：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(1).</strong>在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(2).</strong>在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(3).</strong> 对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理用户信息。
                </li>
              </ul>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">2. 转让</h2>
              <p data-v-1f4d0977="" style="text-align: left;">我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(1).</strong>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(2).</strong>在跨信通与其他法律主体者发生合并、收购情形，或其他涉及合并、收购情形时，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
                </li>
              </ul>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">3. 共享、转让信息时事先征得授权同意的例外</h2>
              <p data-v-1f4d0977="" style="text-align: left;">以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(1).</strong>与国家安全、国防安全有关的；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(2).</strong>与公共安全、公共卫生、重大公共利益有关的；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(3).</strong> 与犯罪侦查、起诉、审判和判决执行等有关的；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(4).</strong>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(5).</strong>您自行向社会公众公开的个人信息；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(6).</strong>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                </li>
              </ul>
              <p data-v-1f4d0977="" style="text-align: left;">我们收集的个人信息包括但不限于：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">身份识别信息：</strong>姓名、电子邮件地址、电话号码等。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">账户信息：</strong>用户名、密码、登录日志等。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">交易信息：</strong> 订单信息、支付信息等。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">设备信息：</strong>IP地址、设备类型、操作系统、浏览器信息等。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">位置信息：</strong>在您同意的情况下，我们可能会收集您的位置信息。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">其他信息：</strong>您在使用我们服务时主动提供的信息。
                </li>
              </ul>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">二、信息使用目的</h2>
              <p data-v-1f4d0977="" style="text-align: left;">我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(a).</strong>本网站不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本网站（含本网站关联公司）单独或共同为您提供服务。主要场景有向合作的第三方仓储物流公司提供订单详细信息，以为您提供订单履约服务；经过您的授权向第三方软件服务商提供信息，便于第三方软件服务商为您提供订单处理服务。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(b).</strong>本网站亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本网站平台用户如从事上述活动，一经发现，本网站有权立即终止与该用户的服务协议。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(c).</strong>为服务用户的目的，本网站可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息。
                </li>
              </ul>
              <p data-v-1f4d0977="" style="text-align: left;">我们从 Walmart 获取的个人信息仅限于以下目的：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  提供沃尔玛卖家服务，包括订单处理、履约管理、财务报表生成等功能。
                </li>
                <li data-v-1f4d0977="">
                  根据 Walmart 的要求，我们仅收集、处理和使用必要的订单数据，并保证不会将数据用于与服务无关的其他目的。
                </li>
                <li data-v-1f4d0977="">
                  我们会确保您提供的所有数据在合法、安全的环境下处理，完全符合 Walmart API 安全标准和隐私要求。
                </li>
              </ul>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">三、法律依据</h2>
              <p data-v-1f4d0977="" style="text-align: left;">在如下情况下，本网站将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(a).</strong>经您事先同意，向第三方披露；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(b).</strong>为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(c).</strong>根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(d).</strong>如您出现违反中国有关法律、法规或者本网站服务协议或相关规则的情况，需要向第三方披露；
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(e).</strong>在本网站平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本网站有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。  
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(f).</strong>其它本网站根据法律、法规或者网站政策认为合适的披露。
                </li>
              </ul>
              <p data-v-1f4d0977="" style="text-align: left;">我们处理您的个人信息，均基于以下法律依据：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">您明确的同意：</strong>在大多数情况下，我们会征得您的明确同意。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">履行合同：</strong>为提供您所要求的服务。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">合法权益：</strong>在不损害您的权益的前提下，为维护我们的合法权益。  
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">法律义务：</strong>遵守法律法规的要求。
                </li>
              </ul>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">四、数据主体权利</h2>
              <p data-v-1f4d0977="" style="text-align: left;">在如下情况下，本网站将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">授权和数据访问限制：</strong>在使用我们的平台时，卖家需要为我们提供必要的API访问权限，以便我们能够有效地提供服务。我们仅会请求与订单处理、库存管理、物流追踪及报表分析相关的权限，不会请求超出服务范围的其他权限。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">授权撤回流程：</strong>卖家应随时有权查看或修改其API授权，并可以要求撤销全部或部分授权。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">OAuth 2.0 授权：</strong>卖家可通过 Walmart Seller Center App Store 点击 Connect 授权本应用；授权基于 OAuth 2.0 标准，卖家可随时撤销授权。我们仅访问卖家授权范围内的数据。
                </li>
              </ul>
              <p data-v-1f4d0977="" style="text-align: left;">您可以通过我们平台上的API管理页面随时查看、修改或撤销已授予的API权限。任何撤销或修改均会在24小时内生效，并且我们将相应删除或停止访问相关数据。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">五、数据安全</h2>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(a).</strong>本网站帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本网站将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">(b).</strong>在使用本网站网络服务进行，您不可避免的要向合作服务方（如物流商，海外仓等）披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。在任何情况下，如需将数据共享给第三方（如物流商、会计服务商），我们将采取合同约束及数据保护协议（DPA），确保第三方处理数据时符合与我们相同的隐私和安全标准。
                </li>
              </ul>
              <p data-v-1f4d0977="" style="text-align: left;">我们采取了先进的技术和组织措施以保护您的个人信息，包括但不限于：</p>
              <ul data-v-1f4d0977="" style="text-align: left;">
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">数据加密：</strong>我们对通过 Walmart Marketplace API 传输的所有敏感数据（如买家PII）进行AES-256加密，并确保在存储时的数据安全性。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">访问控制： </strong>只有经过授权的员工和合作方才能访问 Walmart 卖家或买家的个人数据。所有访问都经过严格审查，并遵循最小权限原则。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">定期审查和监控： </strong>我们会定期对系统进行安全扫描，监控潜在威胁，并在必要时进行漏洞修复。  
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">数据泄露应急响应： </strong>若发生任何数据泄露事件，我们将立即启动应急预案，并在24小时内通知受影响的用户和相关监管机构，遵循 Walmart 的数据安全与报告要求。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">管理员角色：</strong>仅管理员有权限查看、修改及删除敏感数据（如客户PII、订单历史记录）。所有操作均需经过双因素认证，并在内部日志中记录。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">员工角色： </strong>普通员工只能查看与其职能相关的订单信息及物流数据，无法访问买家PII或账户信息。
                </li>
                <li data-v-1f4d0977="">
                  <strong data-v-1f4d0977="">API调用权限：</strong>我们严格遵循 Walmart Marketplace API 的调用规则，确保所有敏感数据访问仅限于服务提供的实际需要（如订单处理和物流履约），并定期审查权限。卖家通过 OAuth 2.0 授权连接应用，我们仅访问授权范围内的数据。
                </li>
                <li data-v-1f4d0977="">
                  所有用户的系统访问及数据操作行为均会记录在访问日志中。我们会定期审查所有敏感数据的访问情况，确保权限设置符合最小化原则，并防止任何未经授权的数据访问行为。
                </li>
                <li data-v-1f4d0977="">
                  每次 Walmart API 接口的调用都会在日志中记录，包括访问者的身份、数据请求类型及时间。
                </li>
                <li data-v-1f4d0977="">
                  每季度我们将进行内部权限审查，以确保所有访问权限符合 Walmart 的合规要求，并删除不必要的访问权限。
                </li>
              </ul>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">六、数据保留</h2>
              <p data-v-1f4d0977="" style="text-align: left;">我们仅在必要时保留您的个人信息，并遵循最小化原则。当您的个人信息不再需要用于上述目的时，我们将采取合理措施删除或匿名化您的个人信息。</p>
              <p data-v-1f4d0977="" style="text-align: left;">您可以随时通过系统管理界面或联系我们的客服团队，申请访问、更正或删除您的数据。如涉及 Walmart 买家 PII 数据的删除或修改请求，我们将先行验证您的身份，并确保该操作符合 Walmart API 的数据处理规则。我们承诺在收到请求后30个工作日内完成您的数据管理操作，并向您提供变更记录和确认信息。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">七、跨境数据传输</h2>
              <p data-v-1f4d0977="" style="text-align: left;">本网站收集的有关您的信息和资料将保存在本网站及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本网站收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
              <p data-v-1f4d0977="" style="text-align: left;">我们可能会将通过 Walmart Marketplace API 获取的数据传输到我们在其他国家/地区的服务器进行处理，但在任何跨境传输过程中，我们均会遵循相关数据保护法律法规，并采取必要的安全措施，如数据加密和签订数据保护协议，确保数据的安全和隐私不受侵犯。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">八、隐私影响评估（PIA）</h2>
              <p data-v-1f4d0977="" style="text-align: left;">本网站搜集到的所有信息的存储、传输和使用都会严格遵守信息存储所在地政府的相关规定，妥善保管和使用。订单中包含的用户个人信息（主要是收货人信息）在订单完成之后1个月内删除，且总的存储时间最长不超过3个月。用户个人（包含内部用户和外部客户）信息在账号注销1个月内删除。</p>
              <p data-v-1f4d0977="" style="text-align: left;">对于可能涉及大量沃尔玛卖家及买家个人信息的处理活动，我们会提前进行隐私影响评估（PIA），确保数据处理不会对用户隐私权产生重大影响，并且符合GDPR和CCPA的相关规定。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">九、Cookie的使用</h2>
              <p data-v-1f4d0977="" style="text-align: left;">我们使用Cookie来收集您的信息，以便为您提供更好的服务。您可以通过浏览器设置来管理Cookie。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">十、儿童隐私</h2>
              <p data-v-1f4d0977="" style="text-align: left;">1. 我们主要面向成人提供产品和服务。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</p>
              <p data-v-1f4d0977="" style="text-align: left;">2. 对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">十一、本政策的变更</h2>
              <p data-v-1f4d0977="" style="text-align: left;">我们可能会适时对本隐私权进行更新。当相关条款发生变更时，我们会在你登录及版本更新时以网站公示、推送通知、弹窗的形式向你展示变更后的隐私权政策。一旦您继续使用xxxERP服务，将被视为对更新后的隐私权政策的接受和认可。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">十二、联系我们</h2>
              <p data-v-1f4d0977="" style="text-align: left;">如果您对本隐私政策有任何疑问，请联系我们的客服（邮箱：zoujianzhou@qianyuanhk.com）我们将在收到相关信息后的10个工作日内回复您。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">十三、投诉</h2>
              <p data-v-1f4d0977="" style="text-align: left;">如果您对我们处理您的个人信息有任何不满，您可以向当地数据保护监管机构投诉。</p>
            </section>
            <section data-v-1f4d0977="" class="policy">
              <h2 data-v-1f4d0977="" style="text-align: left;">重要声明：</h2>
              <p data-v-1f4d0977="" style="text-align: left;">本隐私政策可能因法律法规的变更而更新，请以最新版本为准。</p>
              <p data-v-1f4d0977="" style="text-align: left;">本隐私政策仅适用于xxxERP提供的服务，不适用于其他第三方网站或应用程序。</p>
            </section>
          </div>
        </main>
      </div>
    </main>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.en-main[data-v-109a143a],
.footer[data-v-109a143a],
.main[data-v-109a143a] {
  width: 100%;
}
main {
  display: block;
  unicode-bidi: isolate;
}
main[data-v-1f4d0977] {
    margin-top: 1.25rem;
}
.privacy-view[data-v-1f4d0977] {
    padding: 1.25rem;
    background-color: #fff;
    border-radius: .625rem;
    box-shadow: 0 0 .625rem rgba(0, 0, 0, .1);
    width: 75rem;
    margin: 3.125rem auto;
}
header[data-v-1f4d0977] {
    background-color: #036;
    color: #fff;
    padding: 0.9rem 0;
}
header .container[data-v-1f4d0977] {
    text-align: center;
}
header h1[data-v-1f4d0977] {
    margin: 0;
    color: #fff;
    font-size: 16px;
}
main .container[data-v-1f4d0977] {
    max-width: 62rem;
    margin: 0 auto;
    background-color: #fff;
    padding: 1.25rem;
    border-radius: .5rem;
    box-shadow: 0 .125rem .625rem rgba(0, 0, 0, .1);
}
section {
    display: block;
    unicode-bidi: isolate;
}
section h2[data-v-1f4d0977] {
    font-size: 1.5rem;
    margin-bottom: .625rem;
    color: #036;
}
section p[data-v-1f4d0977] {
  font-size: 11px;
    margin-bottom: .9375rem;
}
p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    unicode-bidi: isolate;
}
section ul[data-v-1f4d0977] {
    list-style-type: disc;
    margin-left: 1.25rem;
    list-style: none;
}
section ul li[data-v-1f4d0977] {
    margin-bottom: .625rem;
    font-size: 13px;
}
</style>